import i18n from 'i18n';
import {
  ValueGetterParams,
  ITooltipParams,
  ColDef,
} from '@ag-grid-enterprise/all-modules';

export default function getFieldFromFirstInterfaceNameValueGetter<T, U>(
  interfaceName: keyof T,
): (params: Partial<ValueGetterParams> | Partial<ITooltipParams>) => string {
  return ({ data, colDef }: Partial<ValueGetterParams> | Partial<ITooltipParams>): string => {

    const interfaceConfig = data as T;
    const [interfaceData] = (interfaceConfig[interfaceName] || []) as U[];
    const field = (colDef as ColDef).field as keyof U;

    if (!interfaceData) {
      return i18n.t('common.grid.empty');
    }

    return (`${interfaceData[field] || i18n.t('common.grid.empty')}`);
  };
}
